import { useCallback } from "react";
import expenseService from "../services/expenseService";
import buildExpenseFormData from "../services/buildExpenseFormData";


const useExpenseSubmit = ({

    mode,

    expenseId,

}) => {

    //----------------------------------------------------

    const submit = useCallback(

        async (values) => {

            const formData =

                buildExpenseFormData(values);

            if (

                mode === "create"

            ) {

                return await expenseService.createExpense(

                    formData

                );

            }

            return await expenseService.updateExpense(

                expenseId,

                formData

            );

        },

        [

            mode,

            expenseId,

        ]

    );

    //----------------------------------------------------

    return submit;

};

export default useExpenseSubmit;